import styled from 'styled-components';
import AuctionCalendar from './calander/Calander';
import { useEffect, useState } from 'react';
import LoanInfoService from '../../../service/LoanInfo';
import { isLogin } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';

const MainCalendar = () => {
  const { modalDispatch } = useModal();
  const [court, setCourt] = useState<string>('');
  const [tabCategory, setTabCategory] = useState<string>('a');
  const [calendarData, setCalendarData] = useState([]);
  const [curCalendarData, setCurCalendarData] = useState([]);
  const [total, setTotal] = useState<number>(0);
  const [selectedDate, setSelectedDate] = useState(
    new Date()
      .toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(/\. /g, '-')
      .replace('.', ''),
  );

  const getData = async () => {
    try {
      const res = await LoanInfoService.calendar(
        court,
        '',
        selectedDate,
        tabCategory,
        '',
        20,
        0,
      );
      setTotal(res.data.totalNumber);
      setCalendarData(res.data.calendar);
      setCurCalendarData(res.data.cur_calendar);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getData();
  }, [tabCategory, selectedDate]);

  return (
    <Section>
      <AuctionCalenderBox>
        <TitleSection>
          <Title>경매 달력</Title>
          <AuctionTabBox>
            <AuctionTab
              active={tabCategory === 'a'}
              onClick={() => setTabCategory('a')}
            >
              경매일정
            </AuctionTab>
            <AuctionTab
              active={tabCategory === 'n'}
              onClick={() => setTabCategory('n')}
            >
              경매신건
            </AuctionTab>
            <AuctionTab
              active={tabCategory === 's'}
              onClick={() => {
                if (!isLogin()) {
                  modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
                  return;
                }
                setTabCategory('s');
              }}
            >
              입찰결과
            </AuctionTab>
          </AuctionTabBox>
        </TitleSection>

        <AuctionCalendarInner>
          <AuctionCalendar
            page="main"
            court={court}
            setCourt={setCourt}
            calendarData={calendarData}
            curCalendarData={curCalendarData}
            tabCategory={tabCategory}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        </AuctionCalendarInner>
      </AuctionCalenderBox>
    </Section>
  );
};

export default MainCalendar;

interface IRegionTab {
  active: boolean;
}

const Section = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px 24px 16px;
`;

const AuctionCalenderBox = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  border-radius: 16px;
  background: #fff;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Title = styled.div`
  color: rgba(0, 12, 30, 0.8);
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const AuctionCalendarInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const AuctionTabBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const AuctionTab = styled.div<IRegionTab>`
  width: 80px;
  // height: 46px;
  display: flex;
  gap: 8px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  color: ${({ active }) => (active ? '#fff' : '#989ba2')};
  // border: 1px solid rgba(112, 115, 124, 0.16);
  border-bottom: none;
  border-radius: 9999px;
  cursor: pointer;
  background-color: ${({ active }) =>
    active ? '#222' : 'rgba(112, 115, 124, 0.08)'};
`;
